import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import type { Volume } from '../data/content';
interface AccordionProps {
  items: Volume[];
  accent?: 'gold' | 'navy';
}
export function Accordion({
  items,
  accent = 'gold'
}: AccordionProps) {
  const [open, setOpen] = useState<number | null>(0);
  return <div className="flex flex-col gap-3" data-id="element-2">
      {items.map((item, i) => {
      const isOpen = open === i;
      return <div key={item.title} className="overflow-hidden rounded-xl border border-white/10 bg-navy-light/70 backdrop-blur" data-id="element-3">
            {item.imageUrl && <img src={item.imageUrl} alt={`Vista previa de ${item.title}`} className="max-h-56 w-full border-b border-white/10 bg-white object-contain" data-id="element-4" />}
            <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center gap-3 px-4 py-4 text-left" data-id="element-5">
              <span className="text-2xl leading-none" data-id="element-6">{item.emoji}</span>
              <span className="flex-1 text-sm font-bold text-white" data-id="element-7">
                {item.title}
              </span>
              <motion.span animate={{
            rotate: isOpen ? 180 : 0
          }} transition={{
            duration: 0.2
          }} className={accent === 'gold' ? 'text-gold' : 'text-white'} data-id="element-8">
                <ChevronDownIcon className="h-5 w-5" data-id="element-9" />
              </motion.span>
            </button>
            <AnimatePresence initial={false} data-id="element-10">
              {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.25
          }} data-id="element-11">
                  <ul className="space-y-2 border-t border-white/10 px-5 py-4" data-id="element-12">
                    {item.items.map(li => <li key={li} className="flex gap-2 text-sm leading-relaxed text-slate-200" data-id="element-13">
                        <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" data-id="element-14" />
                        <span data-id="element-15">{li}</span>
                      </li>)}
                  </ul>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}